import React from 'react';
import PropTypes from 'prop-types';
import HtmlHelper from '../../../general/js/html-helper';

const NOTIFICATION_TYPE_PROPERTY = 'Property';
const NOTIFICATION_TYPE_INFO = 'Info';

export default class NotificationItem extends React.PureComponent {

    constructor(props) {
        super(props);

        this.onCloseClick = this.onCloseClick.bind(this);
    }

    onCloseClick(e) {
        this.props.onClose(this.props.item);
    }

    getClass() {
        let result = 'notification--info';
        switch (this.props.item.type) {
            case NOTIFICATION_TYPE_PROPERTY:
                result = 'notification--property';
                break;
            case NOTIFICATION_TYPE_INFO:
                result = 'notification--info';
                break;
        }

        return result;
    }

    render() {
        let item = this.props.item;
        return (
            <div className={`toast notification ${this.getClass()}`} aria-live="polite">
                <button type="button" className="notification__close-btn toast-close-button" role="button" onClick={this.onCloseClick}>
                    ×
                </button>
                <div className="notification__container">
                    {item.imgUrl ?
                        <div className="notification__img">
                            <img data-srcset={HtmlHelper.getSrcSet(item.imgUrl)} data-sizes="auto"
                                 className="lazyload" alt=""/>
                        </div>
                        : null}
                    <div className="notification__content">
                        <div className="toast-title" dangerouslySetInnerHTML={{__html: item.title}}></div>
                        <div className="toast-message" dangerouslySetInnerHTML={{__html: item.text}}></div>
                    </div>
                </div>
            </div>
        );
    }
}

NotificationItem.propTypes = {
    item: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./app/components/notifications/js/NotificationItem.js